/*
Based on Material Dashboard 2 React by Creative Tim (https://www.creative-tim.com)
Licensed under the MIT License (see LICENSE)

Original Copyright (c) 2013-2021 Creative Tim
Modifications (c) 2025 CodeWeave Solutions (Pty) Ltd
*/

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";

const { borderRadius } = borders;

const avatar = {
  styleOverrides: {
    root: {
      transition: "all 200ms ease-in-out",
    },

    rounded: {
      borderRadius: borderRadius.lg,
    },

    img: {
      height: "auto",
    },
  },
};

export default avatar;
